import React from "react";
import { Button, Card, Picture, Text, Icon, Box, Badge } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import Doughnut from "~/components-shared/Doughnut";
import lists from "~/lib/lists";
import { helpers } from "~/lib/helpers";
import { genericColor } from "~/lib/resolvers";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const List = styled.ul`
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.text.secondary;
}};
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  font-size: 12px;
`;
const ListItem = styled.li``;
const Color = styled.i`
  background-color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColor(theme, $color);
}};
  width: 12px;
  height: 12px;
  margin-left: 5px;
  border-radius: 50%;
  display: inline-block;
`;
const ContributionsCard = _ref3 => {
  let {
    size,
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref3;
  const theme = useTheme();
  const {
    current,
    previous
  } = widget.data;
  const currentSum = Object.values(current.bySource).reduce((p, c) => p + c, 0);
  const previousSum = Object.values(previous.bySource).reduce((p, c) => p + c, 0);
  const deltaPercentage = previous.total === 0 ? 0 : (current.total - previous.total) / previous.total * 100;
  const currentMapped = Object.keys(current.bySource).map(source => ({
    name: lists.topics.footprintSources.names[source],
    color: lists.topics.footprintSources.colors(theme)[source],
    percent: current.bySource[source] / currentSum * 100,
    value: current.bySource[source]
  }));
  const previousMapped = Object.keys(previous.bySource).map(source => ({
    name: lists.topics.footprintSources.names[source],
    color: lists.topics.footprintSources.colors(theme)[source],
    percent: previous.bySource[source] / previousSum * 100,
    value: previous.bySource[source]
  }));
  const sources = [...Object.keys(current.bySource), ...Object.keys(previous.bySource)].filter(helpers.onlyUnique);
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 1
    }
  }, "Contributions"), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    justify: "center",
    direction: "column",
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Doughnut, {
    size: 52,
    contents: /*#__PURE__*/React.createElement(Box, {
      align: "center",
      direction: "column"
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 9,
      lineHeight: 9,
      weight: "bold",
      color: "text",
      display: "block"
    }, current.total), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      align: "center",
      s: {
        mb: 1
      }
    }, currPeriod), /*#__PURE__*/React.createElement(Badge, {
      fontSize: 3.5,
      weight: "semiBold",
      color: deltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: deltaPercentage > 0 ? 0 : 180
    }), deltaPercentage.toFixed(0), "%"))
  }, /*#__PURE__*/React.createElement(Doughnut.Arc, {
    width: 5,
    values: currentMapped.map(_ref4 => {
      let {
        percent
      } = _ref4;
      return percent;
    }),
    colors: currentMapped.map(_ref5 => {
      let {
        color
      } = _ref5;
      return color;
    }),
    labels: currentMapped.map(_ref6 => {
      let {
        value,
        name
      } = _ref6;
      return `${value} ${name} (${currPeriod})`;
    })
  }), /*#__PURE__*/React.createElement(Doughnut.Arc, {
    opacity: 0.4,
    scale: 0.83,
    width: 5,
    values: previousMapped.map(_ref7 => {
      let {
        percent
      } = _ref7;
      return percent;
    }),
    colors: previousMapped.map(_ref8 => {
      let {
        color
      } = _ref8;
      return color;
    }),
    labels: previousMapped.map(_ref9 => {
      let {
        value,
        name
      } = _ref9;
      return `${value} ${name} (${prevPeriod})`;
    })
  })), /*#__PURE__*/React.createElement(List, null, sources.map(source => /*#__PURE__*/React.createElement(ListItem, {
    key: source
  }, /*#__PURE__*/React.createElement(Color, {
    $color: lists.topics.footprintSources.colors(theme)[source]
  }), /*#__PURE__*/React.createElement(Picture, {
    width: "1.2rem",
    height: "1.2rem",
    display: "inline-block",
    src: lists.common.apps.logos(theme)[source],
    s: {
      ml: 2,
      mb: -0.5
    },
    border: "squared",
    backgroundSize: "contain"
  }))))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Footprints members produced in different types of sources within designated period of time",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })));
};
export default ContributionsCard;